import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_transaction = (id) => {
  return api.delete(`${ApiEndpointConstants.DELETETRANSACTION}`, {
    data: { id },
  });
};
